export default __webpack_public_path__ + "static/media/Node.85ce625c.png";